import { render, staticRenderFns } from "./TodoListForm.vue?vue&type=template&id=2dc83d9e&scoped=true&"
import script from "./TodoListForm.vue?vue&type=script&lang=js&"
export * from "./TodoListForm.vue?vue&type=script&lang=js&"
import style0 from "./TodoListForm.vue?vue&type=style&index=0&id=2dc83d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc83d9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDatePicker,VIcon,VMenu,VPagination,VRow,VSelect,VTextField})
